module.exports = {
  "@ux/accordion": "15.0.2",
  "@ux/alert": "12.0.1",
  "@ux/button": "19.0.3",
  "@ux/button-set": "12.1.0",
  "@ux/checkbox": "13.0.1",
  "@ux/checkbox-group": "13.0.0",
  "@ux/code": "5.0.0",
  "@ux/collapsible": "13.0.1",
  "@ux/component": "9.1.1",
  "@ux/containers": "6.0.1",
  "@ux/criteria": "12.0.2",
  "@ux/dropdown": "16.1.0",
  "@ux/fieldset": "7.0.0",
  "@ux/form": "14.0.1",
  "@ux/form-element": "17.0.2",
  "@ux/form-group": "8.0.1",
  "@ux/growl": "8.0.1",
  "@ux/icon": "12.0.1",
  "@ux/inline-styles": "13.0.3",
  "@ux/message-overlay": "11.0.1",
  "@ux/modal": "13.0.1",
  "@ux/namespace-component": "7.3.1",
  "@ux/pagination": "8.0.1",
  "@ux/palette-api-client": "4.0.0",
  "@ux/palettes": "5.4.1",
  "@ux/password": "13.0.2",
  "@ux/pivot": "8.2.1",
  "@ux/progress-bar": "10.1.2",
  "@ux/progress-steps": "9.0.4",
  "@ux/quantity-selector": "11.0.0",
  "@ux/radio": "13.0.2",
  "@ux/radio-group": "13.0.1",
  "@ux/react-native-device-fonts": "3.0.1",
  "@ux/remaining": "8.0.1",
  "@ux/scss-common": "8.1.7",
  "@ux/scss-definitions": "8.0.11",
  "@ux/search": "9.0.1",
  "@ux/spinner": "9.0.3",
  "@ux/stars": "8.0.1",
  "@ux/table": "8.0.0",
  "@ux/tabs": "14.1.1",
  "@ux/telephone-input": "9.2.0",
  "@ux/toggle": "12.0.2",
  "@ux/tooltip": "13.0.2",
  "@ux/transition": "6.0.0",
  "@ux/util": "5.0.1",
  "@ux/webpack-config": "10.2.2",
  "@ux/uxcore2": "13.1.2"
};


// WEBPACK FOOTER //
// ./js/versions.static.js